import React from 'react';

/**
 * Footer minimale dell'applicazione.
 * Mostra il copyright e la versione del sistema.
 */
const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        backgroundColor: '#0f172a',
        color: '#94a3b8',
        textAlign: 'center',
        padding: '1rem',
        fontSize: '0.8rem',
        borderTop: '1px solid #1e293b',
        marginTop: 'auto',
      }}
    >
      <p style={{ margin: 0 }}>
        © {currentYear} V‑Spot — Video Analytics per Pallavolo
      </p>
      <p style={{ margin: '0.25rem 0 0 0' }}>
        Versione 0.1.0 — Tutti i diritti riservati
      </p>
    </footer>
  );
};

export default Footer;